export * from './input-color.component';
